module.exports = __webpack_public_path__ + "static/media/4530.31ae75c3.jpg";